export const ITEMSCLASSES = {
    'extra_strength': {
        name: 'Усиление',
        discription:
            `
            Экстра, повышающая силу текущего удара в X раз.
            Применяется в свой ход перед выбором техники удара. 
        `
    },
    'extra_sbiv': {
        name: 'Сбив',
        discription:
            `
            Экстра, позволяющая ударом бенсао перебить атаку противника.
            Применяется в ход противника, меняет активные действия на атаки. 
        `
    },
    'extra_uklon': {
        name: 'Отпрыг',
        discription:
            `
            Экстра универсального ухода от любой атаки противника.
            Применяется в ход противника, сразу включает уклон. 
        `
    },
    'extra_ectangle': {
        name: 'Кандалы',
        discription:
            `
            Экстра, заставляющая врага двигаться медленнее и срезающая урон.
            Применяется в свой ход вместе с ударом в нижнюю чать.
        `
    },
    'extra_heal': {
        name: 'Лечение',
        discription:
            `
            Экстра, пассивно восстанавливающая ХП, если лежит в ячейке.
            При применении восстанавливает больше ХП сразу.
        `
    },
    'extra_triple': {
        name: 'Серия',
        discription:
            `
            Экстра, срабатывает, когда нанесены три удара во все зоны.
            Срабатывает бафф в зависимости от последнего удара.
            Верх - усиление.
            Середина - лечение.
            Низ - кандалы.
        `
    }
}

export const EXTRASPARAMS = {
    otkat: { label: 'Откат' },
    innerLeft: { label: 'Длительность' },
    result_innerLeft: { label: 'Продолжительность' },
    strengthX: { label: 'Усиление', adderText: 'X' },
    heal: { label: 'Лечение' },
    passive_heal: { label: 'Пасс. лечение' },
    speedMinus: { label: 'Замедление' },
    forcePercentMinus: { label: 'Ослабление', adderText: '%' },
}

// НЕ ЗАБЫВАТЬ ДОБАВИТЬ И В CLIENT-ITEMS
const REALITEMS = {
    sbiv_1_a: {
        name: 'sbiv_1_a',
        type: 'wear',
        lvl: 1,
        desctructed: false, // удаляется после применения, или делает count - 1
        // count:
        counted: true,
        specIcon: null,
        settings:
            { type: 'sbiv', otkat: 5, innerLeft: 1 }
    },
    strength_1_a: {
        name: 'strength_1_a',
        itemClass: 'extra_strength',
        type: 'extra',
        lvl: 1,
        desctructed: false, // удаляется после применения, или делает count - 1
        // count:
        counted: true,
        specIcon: null,
        settings:
            { type: 'strength', otkat: 7, innerLeft: 1, strengthX: 1.5 }
    },
    strength_2_a: {
        name: 'strength_2_a',
        itemClass: 'extra_strength',
        type: 'extra',
        lvl: 4,
        grade: 4,
        desctructed: false, // удаляется после применения, или делает count - 1
        // count:
        counted: true,
        specIcon: 'strength_2_purple',
        settings:
            { type: 'strength', otkat: 6, innerLeft: 1, strengthX: 1.7 }
    },
    uklon_1_a: {
        name: 'uklon_1_a',
        itemClass: 'extra_uklon',
        type: 'extra',
        lvl: 1,
        desctructed: false, // удаляется после применения, или делает count - 1
        // count:
        counted: true,
        specIcon: null,
        settings:
            { type: 'uklon', otkat: 5, innerLeft: 1 }
    },
    ectangle_1_a: {
        name: 'ectangle_1_a',
        itemClass: 'extra_ectangle',
        type: 'extra',
        lvl: 1,
        desctructed: false, // удаляется после применения, или делает count - 1
        // count:
        counted: true,
        specIcon: null,
        settings:
        {
            type: 'ectangle',
            otkat: 6,
            innerLeft: 1,
            strengthX: 1.8,
            immediately: true,
            resultBuff: {
                type: 'ectangled',
                innerLeft: 4,
                speedMinus: 3,
                forcePercentMinus: 40,
                immediately: true
            },
        }
    },

    triple_1_a: {
        name: 'triple_1_a',
        itemClass: 'extra_triple',
        type: 'extra',
        lvl: 1,
        desctructed: false, // удаляется после применения, или делает count - 1
        // count:
        counted: true,
        specIcon: null,
        settings:
        {
            type: 'triple', otkat: 7, innerLeft: 6, hitBuffs: {
                1: {
                    type: 'strength',
                    innerLeft: 1,
                    strengthX: 2.6,
                    immediately: true
                },
                2: {
                    type: 'heal',
                    heal: 3.5,
                    innerLeft: 1,
                    immediately: true
                },
                3: {
                    type: 'ectangle',
                    resultBuff: {
                        type: 'ectangled',
                        innerLeft: 4,
                        speedMinus: 3,
                        forcePercentMinus: 60,
                        immediately: true
                    },
                    innerLeft: 1,
                    strengthX: 1.8,
                    immediately: true
                },
            }
        }
    },

    heal_1_a: {
        name: 'heal_1_a',
        itemClass: 'extra_heal',
        type: 'extra',
        lvl: 1,
        desctructed: false, // удаляется после применения, или делает count - 1
        // count:
        counted: true,
        specIcon: null,
        settings:
        {
            type: 'heal', otkat: 7, innerLeft: 1,
            heal: 3.5,
            passiveBuff: {
                type: 'heal',
                innerLeft: 1,
                heal: 0.45,
                immediately: true
            }
        }
    },
}

const REALWEAR = {
    snw_berimba_1_a: {
        name: 'snw_berimba_1_a',
        itemClass: 'extra_sbiv',
        type: 'extra',
        lvl: 1,
        desctructed: false, // удаляется после применения, или делает count - 1
        // count:
        counted: true,
        specIcon: null,
        settings:
            { 
                type: 'sbiv', otkat: 5, innerLeft: 1 
            }
    },
}

// тут еще отдельно айтемы в пещерах
export const ITEMS = {
    extra_strength_1_incave_a: {
        // id будет как-то дописываться
        name: 'extra_strength_1_incave_a',
        itemClass: 'extra_strength',
        type: 'extra',
        lvl: 1,
        inCave: true,
        desctructed: true,
        // count:
        counted: true,
        specIcon: null,
        settings:
            { type: 'strength', otkat: 10, innerLeft: 1, strengthX: 2 }
    },

    extra_sbiv_1_incave_a: {
        // id будет как-то дописываться
        name: 'extra_sbiv_1_incave_a',
        itemClass: 'extra_sbiv',
        type: 'extra',
        lvl: 1,
        inCave: true,
        desctructed: true, // удаляется после применения, или делает count - 1
        // count:
        counted: true,
        specIcon: null,
        settings:
            { type: 'sbiv', otkat: 5, innerLeft: 1 }
    },
    extra_uklon_1_incave_a: {
        // id будет как-то дописываться
        name: 'extra_uklon_1_incave_a',
        itemClass: 'extra_uklon',
        type: 'extra',
        lvl: 1,
        inCave: true,
        desctructed: true, // удаляется после применения, или делает count - 1
        // count:
        counted: true,
        specIcon: null,
        settings:
            { type: 'uklon', otkat: 5, innerLeft: 1 }
    },
    ...REALITEMS,
    ...REALWEAR
}